import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { getBrandBasedIn } from "@faire/help-center-utils/serialized-data/getBrand";
import { ISelfServeBrandOrder } from "@faire/web-api/indigofair/helpcenter/ISelfServeBrandOrder";
import { ISO3166Alpha3 } from "@faire/web-api/indigofair/iso3166/ISO3166Alpha3";
import { NODE_IS_NOT_VISIBLE, NODE_IS_VISIBLE } from "../../api/consts";
export var orderUnknownStateVisibilityFn = function orderUnknownStateVisibilityFn(context) {
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_VISIBLE);
  }
  return Promise.resolve(getOrderState(context) === ISelfServeBrandOrder.State.STATE_UNKNOWN);
};
export var orderNewStateVisibilityFn = function orderNewStateVisibilityFn(context) {
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_NOT_VISIBLE);
  }
  return Promise.resolve(getOrderState(context) === ISelfServeBrandOrder.State.NEW);
};
export var orderUnfulfilledStateVisibilityFn = function orderUnfulfilledStateVisibilityFn(context) {
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_NOT_VISIBLE);
  }
  return Promise.resolve(getOrderState(context) === ISelfServeBrandOrder.State.UNFULFILLED);
};
export var orderShippedStateVisibilityFn = function orderShippedStateVisibilityFn(context) {
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_NOT_VISIBLE);
  }
  return Promise.resolve(getOrderState(context) === ISelfServeBrandOrder.State.SHIPPED);
};
export var orderDeliveredStateVisibilityFn = function orderDeliveredStateVisibilityFn(context) {
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_NOT_VISIBLE);
  }
  return Promise.resolve(getOrderState(context) === ISelfServeBrandOrder.State.DELIVERED);
};
export var orderCanceledStateVisibilityFn = function orderCanceledStateVisibilityFn(context) {
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_NOT_VISIBLE);
  }
  return Promise.resolve(getOrderState(context) === ISelfServeBrandOrder.State.CANCELED);
};
export var orderShippedOrDeliveredAndSOYOVisibilityFn = function orderShippedOrDeliveredAndSOYOVisibilityFn(context) {
  var _context$selectedBran;
  if (!context.selectedBrandOrder) {
    return Promise.resolve(NODE_IS_NOT_VISIBLE);
  }
  return Promise.resolve((getOrderState(context) === ISelfServeBrandOrder.State.SHIPPED || getOrderState(context) === ISelfServeBrandOrder.State.DELIVERED) && !((_context$selectedBran = context.selectedBrandOrder) !== null && _context$selectedBran !== void 0 && _context$selectedBran.is_ship_with_faire) && getBrandBasedIn() === ISO3166Alpha3.USA);
};
var getOrderState = function getOrderState(context) {
  var selectedBrandOrder = context.selectedBrandOrder;
  var _ref = selectedBrandOrder !== null && selectedBrandOrder !== void 0 ? selectedBrandOrder : {},
    state = _ref.state;
  return state;
};